// @flow

import { CHATBOT_EVENTS, WIZARD_EVENTS } from '../../../main/eventTracking'

export function addToCartDrJoseph (customerId: string, subscriberId: string, productId: string): Promise<any> {
  if (!window.addToCartChatchampEventListeners) {
    window.addToCartChatchampEventListeners = true

    window.addEventListener(CHATBOT_EVENTS.AddedToCart, _addSingleProduct)
    window.addEventListener(CHATBOT_EVENTS.RoutineAddedToCart, _addMultipleProducts)
    window.addEventListener(WIZARD_EVENTS.AddedToCartEvent, _addSingleProduct)
    window.addEventListener(WIZARD_EVENTS.RoutineAddedToCartEvent, _addMultipleProducts)
  }

  return Promise.resolve()
}

function _addSingleProduct (event: CustomEvent): void {
  window.addToCartChatchamp(event.detail.productId)
}

function _addMultipleProducts (event: CustomEvent): void {
  window.addToCartChatchamp(event.detail.productIds)
}
